<template>
  <div
    class="app-root"
    :class="{ 'app-has-global-topbar': showGlobalTopbar, 'app-root--fullscreen-route': isFullscreenRoute }"
  >
    <header v-if="showGlobalTopbar" class="app-global-topbar banner" role="banner">
      <div class="app-global-topbar__inner">
        <div class="app-global-topbar__brand-wrap">
          <img
            class="app-global-topbar__logo"
            src="/img/app-logo.svg"
            alt="App logo"
            width="32"
            height="32"
            loading="eager"
            decoding="async"
          >
          <span class="app-global-topbar__brand">{{ appTitle }}</span>
        </div>
        <nav class="app-global-topbar__center" aria-label="Điều hướng chính">
          <button
            type="button"
            class="app-workplace-icon-btn"
            :class="{ 'is-active': activeTab === 'workplace' }"
            v-tooltip.bottom="'Bảng tin'"
            @click="goToTab('workplace')"
            aria-label="Bảng tin"
          >
            <img class="app-workplace-icon-img" src="/img/sidebar/right/workplace/home.svg" alt="">
          </button>
          <button
            type="button"
            class="app-workplace-icon-btn"
            :class="{ 'is-active': activeTab === 'messenger' }"
            v-tooltip.bottom="'Trò chuyện'"
            @click="goToTab('messenger')"
            aria-label="Trò chuyện"
          >
            <img class="app-workplace-icon-img" src="/img/sidebar/left/chat_normal.svg" alt="">
            <span
              v-if="$store.state.chat.unCountChatRead > 0"
              class="app-workplace-icon-badge"
            >
              {{ $store.state.chat.unCountChatRead > 99 ? "99+" : $store.state.chat.unCountChatRead }}
            </span>
          </button>
          <button
            v-if="canAccessAdminSettings"
            type="button"
            class="app-workplace-icon-btn"
            :class="{ 'is-active': activeTab === 'admin-settings' }"
            v-tooltip.bottom="'Quản lý nội bộ'"
            @click="goToTab('admin-settings')"
            aria-label="Quản lý nội bộ"
          >
            <img class="app-workplace-icon-img" src="/img/sidebar/left/settings_active.svg" alt="">
          </button>
          <button
            v-if="canAccessWiki"
            type="button"
            class="app-workplace-icon-btn"
            :class="{ 'is-active': activeTab === 'wiki' }"
            v-tooltip.bottom="'WIKI'"
            @click="goToTab('wiki')"
            aria-label="WIKI"
          >
            <img class="app-workplace-icon-img" src="/img/sidebar/left/wiki_normal.png" alt="">
          </button>
        </nav>
        <div class="app-global-topbar__spacer" />
        <div class="app-global-topbar__actions">
          <button
            type="button"
            class="app-topbar-icon-btn cursor-pointer"
            id="app-topbar-main-site-btn"
            v-tooltip.bottom="'Mở trang quản lý đơn'"
            @click="openMainSiteInNewTab"
            aria-label="Mở trang web chính"
          >
            <img class="app-topbar-main-site-icon" src="/img/ecom.png" alt="" />
          </button>
          <v-dropdown
            placement="bottom-end"
            :triggers="['click']"
            :distance="8"
            popper-class="app-topbar-notification-dropdown"
          >
            <button
              class="app-topbar-icon-btn cursor-pointer"
              id="app-topbar-notification-btn"
              type="button"
              aria-label="Thông báo"
            >
              <span class="material-icons">notifications</span>
              <md-badge
                v-if="unreadNotifications > 0"
                class="app-topbar-icon-badge"
                :md-content="unreadNotifications > 99 ? '99+' : unreadNotifications"
              />
            </button>
            <template #popper>
              <div class="app-topbar-notification-content">
                <NotificationSideBar />
              </div>
            </template>
          </v-dropdown>

          <v-dropdown
            ref="avatarDropdown"
            placement="bottom-end"
            :triggers="['click']"
            :distance="8"
            popper-class="app-topbar-avatar-dropdown"
          >
            <button
              type="button"
              id="app-topbar-avatar-btn"
              class="app-topbar-icon-btn app-topbar-avatar-btn"
              aria-haspopup="true"
              aria-label="Tài khoản"
            >
              <image-template
                class="app-topbar-avatar-inner"
                :size="'small'"
                :image="user.avatar_url"
                :thumbnail="user.thumbnail"
                :name="user.fullname || user.username"
              />
            </button>
            <template #popper="{ hide }">
              <md-list class="p-0px popover-avatar">
                <md-list-item class="profile" @click="redirectToProfile(hide)">
                  <md-avatar>
                    <image-template
                      :class="'pop-avatar-avatar'"
                      :size="'small'"
                      :image="user.avatar_url"
                      :thumbnail="user.thumbnail"
                      :name="user.fullname || user.username"
                    />
                  </md-avatar>
                  <div class="md-list-item-text">
                    <div class="">
                      <div class="fullname">{{ user.fullname }}</div>
                      <div class="text-300-default neutral_2">Xem trang cá nhân</div>
                    </div>
                  </div>
                </md-list-item>
                <md-list-item @click="openBugReport(hide)">
                  <md-icon>bug_report</md-icon>
                  <span class="md-list-item-text">Báo cáo lỗi</span>
                </md-list-item>
                <md-list-item v-on:click="logout(hide)">
                  <md-icon>logout</md-icon>
                  <span class="md-list-item-text">Đăng xuất</span>
                </md-list-item>
              </md-list>
            </template>
          </v-dropdown>
        </div>
      </div>
    </header>
    <div class="app-root__shell">
      <router-view />
    </div>
    <FormPromptGate v-if="showGlobalTopbar && user && user.id" />
    <BugReportModal />
  </div>
</template>

<script>
import AuthService from "./store/services/AuthService";
import ImageTemplate from "./components/ImageTemplate";
import NotificationSideBar from "./pages/Components/SidebarPlugin/SideBarContent/NotificationSideBar";
import FormPromptGate from "./components/forms/FormPromptGate";
import BugReportModal from "./pages/Components/Modal/BugReportModal";
import { GROUP_CHAT_TYPE } from "./const/const";
import { userManagementOrdersUrl } from "@/helper/userManagementSite";
import { clearClientSession, redirectToLoginPage } from "@/helper/sessionRedirect";

export default {
  name: "App",
  components: {
    ImageTemplate,
    NotificationSideBar,
    FormPromptGate,
    BugReportModal,
  },
  data() {
    return {
      defaultDocumentTitle: process.env.VUE_APP_TITLE || "AGENCY SOCIAL",
    };
  },
  created() {
    if (localStorage.getItem("access_token") && this.$store.state.auth?.user?.id) {
      this.$store.dispatch("refreshSessionProfile");
    }
    this.onVisibilityChange = () => {
      if (
        document.visibilityState === "visible"
        && localStorage.getItem("access_token")
        && this.$store.state.auth?.user?.id
      ) {
        this.$store.dispatch("refreshSessionProfile");
      }
    };
    document.addEventListener("visibilitychange", this.onVisibilityChange);
  },
  beforeDestroy() {
    if (this.onVisibilityChange) {
      document.removeEventListener("visibilitychange", this.onVisibilityChange);
    }
  },
  watch: {
    "$store.state.chat.dataSocket"(newV) {
      if (!newV || typeof newV !== "object") return;
      const groupId = newV.group_id != null ? newV.group_id : newV.group && newV.group.id;
      if (groupId == null) return;
      const off = newV.user_notification_off || [];
      const notViewingThisChat =
        this.$route.name !== "messenger"
        || String(this.$route.params.messenger_id) !== String(groupId);
      const notificationsOn = off.indexOf(this.user.id) === -1;
      if (!notViewingThisChat || !notificationsOn) return;
      if (newV.sender && newV.sender.id !== this.user.id) {
        this.$store.dispatch("alerts/chatNoti", newV);
        this.updateChatTabTitle(newV);
      }
    },
  },
  computed: {
    isFullscreenRoute() {
      return !!(this.$route?.meta && this.$route.meta.fullscreen);
    },
    showGlobalTopbar() {
      if (this.$route?.meta?.hideGlobalTopbar || this.isFullscreenRoute) {
        return false;
      }
      const p = String(this.$route?.path || "").toLowerCase();
      return !(
        p === "/login"
        || p.startsWith("/login/")
        || p === "/dang-nhap"
        || p.startsWith("/dang-nhap/")
        || p === "/auth/login"
        || p.startsWith("/auth/login/")
        || p === "/auth/hub-sunset"
        || p.startsWith("/auth/hub-sunset/")
        || p === "/legacy-social-redirect"
        || p === "/agency-login"
      );
    },
    appTitle() {
      return process.env.VUE_APP_TITLE || "AGENCY SOCIAL";
    },
    user() {
      return this.$store.state.auth.user || {};
    },
    unreadNotifications() {
      return this.$store.state.notification?.unCountRead || 0;
    },
    activeTab() {
      return this.$route?.meta?.tab || "";
    },
    /** Toàn quyền nội bộ (HQ + super admin) — dùng cho mọi menu nâng cao. */
    canAccessAdvancedWorkplace() {
      const u = this.user || {};
      return String(u.company_access || "") === "full" || !!u.is_super_admin;
    },
    canAccessAdminSettings() {
      return Number(this.user?.id) === 119;
    },
    canAccessWiki() {
      return false;
    },
  },
  methods: {
    updateChatTabTitle(data) {
      if (!data || !data.sender || data.sender.id === this.user.id) return;
      let title = this.defaultDocumentTitle;
      const group = data.group || {};
      if (group.type === GROUP_CHAT_TYPE.USER) {
        title = `${data.sender.fullname || data.sender.name} đã nhắn tin cho bạn`;
      } else {
        title = `${data.sender.fullname || data.sender.name} đã nhắn tin vào ${group.name || "nhóm"}`;
      }
      document.title = title;
    },
    openMainSiteInNewTab() {
      const url = userManagementOrdersUrl(this.user);
      if (!url) return;
      window.open(url, "_blank", "noopener,noreferrer");
    },
    async logout(hideDropdown) {
      if (typeof hideDropdown === "function") {
        hideDropdown();
      }
      const fcmToken = localStorage.getItem("cmf_token");
      try {
        await AuthService.logout({ fcm_token: fcmToken });
      } catch (e) {
        void e;
      }
      clearClientSession();
      this.$store.commit("isAuthenticated", { isAuthenticated: false });
      this.$store.commit("updateUser", {});
      redirectToLoginPage(undefined, { force: true });
    },
    redirectToProfile(hideDropdown) {
      if (!this.user?.id) return;
      if (typeof hideDropdown === "function") {
        hideDropdown();
      }
      this.$router.push("/profile/" + this.user.id);
    },
    openBugReport(hideDropdown) {
      if (typeof hideDropdown === "function") {
        hideDropdown();
      }
      this.$modal.show("bug-report-modal");
    },
    async goToTab(tab) {
      const targetPath = await this.getWorkplaceTargetPath(tab);
      if (targetPath && this.$route.path !== targetPath) {
        this.$router.push(targetPath);
      }
    },
    async getWorkplaceTargetPath(tab) {
      const staticRouteMap = {
        workplace: "/new-feeds",
        category: "/category-home",
        "admin-settings": "/admin-settings/groups",
        wiki: "/wiki-home",
      };

      if (tab !== "messenger") {
        return staticRouteMap[tab] || "/new-feeds";
      }

      const groups = () => this.$store.state.chat.chatGroups || [];
      const isInList = (id) =>
        id != null
        && groups().some((g) => String(g.id) === String(id));

      if (!groups().length) {
        await this.$store.dispatch("chat/getChatGroups");
      }

      let messengerId =
        this.$route.params?.messenger_id
        || this.$store.state.chat.chatGroupSelected?.id
        || groups()[0]?.id;

      if (messengerId && !isInList(messengerId)) {
        const { ensureChatGroupInStore } = await import("@/helper/chatGroupStore");
        const row = await ensureChatGroupInStore(this.$store, messengerId);
        if (!row) messengerId = null;
      }

      if (!messengerId) {
        const sel = this.$store.state.chat.chatGroupSelected?.id;
        messengerId = isInList(sel) ? sel : groups()[0]?.id;
      }

      return messengerId ? `/messenger/${messengerId}` : "/new-feeds";
    },
  },
};
</script>

<style lang="scss">
.app-global-topbar.banner {
  flex: 0 0 auto;
  width: 100%;
  height: 52px;
  position: relative;
  /* Cao hơn TopNavbar chat (z-index 1000) trong main-panel — cùng 1000 + vẽ sau sẽ đè header + popover tài khoản. */
  z-index: 1100;
  box-sizing: border-box;
  background:
    radial-gradient(
      circle at top left,
      rgba(59,130,246,0.10),
      transparent 30%
    ),
    radial-gradient(
      circle at top right,
      rgba(168,85,247,0.10),
      transparent 30%
    ),
    linear-gradient(
      to bottom,
      rgba(255,255,255,0.96),
      rgba(248,250,252,0.94)
    );
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.app-global-topbar__inner {
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 0;
  position: relative;
}

.app-global-topbar__spacer {
  flex: 1 1 auto;
}

.app-global-topbar__center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 0;
}

/* Tooltip menu topbar: FloatingVue (Popper) — tránh vue-js-popover lệch do transform/scroll. */
.app-global-topbar .v-popper__popper {
  z-index: 1200 !important;
}

.app-global-topbar .v-popper__inner {
  background: #1f2937;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.app-workplace-icon-btn {
  width: 60px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0;
  &:hover {
    background: #f1f5f9;
  }
  &.is-active {
    background: #fffbeb;
    border-color: #fde68a;
  }
}

.app-workplace-icon-img {
  width: 20px;
  height: 20px;
  display: block;
  filter: brightness(0) saturate(100%) invert(38%) sepia(9%) saturate(624%) hue-rotate(182deg) brightness(92%) contrast(90%);
}

.app-workplace-icon-btn:hover .app-workplace-icon-img,
.app-workplace-icon-btn.is-active .app-workplace-icon-img {
  /* Approx Tailwind amber-500 (#f59e0b) */
  filter: brightness(0) saturate(100%) invert(64%) sepia(62%) saturate(2174%) hue-rotate(359deg) brightness(100%) contrast(96%);
}

.app-workplace-icon-badge {
  position: absolute;
  top: 2px;
  right: 8px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
}

.app-global-topbar__actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.app-topbar-icon-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #d8dae5;
  border-radius: 50%;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .material-icons {
    font-size: 20px !important;
    color: #596073;
  }
}

.app-topbar-main-site-icon {
  width: 16px;
  height: 16px;
  display: block;
  object-fit: contain;
  pointer-events: none;
}

.app-topbar-icon-badge {
  position: absolute !important;
  top: -6px !important;
  right: -8px !important;
}

.app-topbar-avatar-btn {
  padding: 0;
  overflow: hidden;
  cursor: pointer;
}

.app-topbar-avatar-inner {
  width: 100% !important;
  height: 100% !important;
  border-radius: 50%;
  overflow: hidden;
  display: block;
  pointer-events: none;
}

.app-topbar-avatar-inner img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  display: block;
}

.app-topbar-notification-dropdown.v-popper__popper .v-popper__inner,
.app-topbar-avatar-dropdown.v-popper__popper .v-popper__inner {
  padding: 0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(52, 73, 94, 0.2);
  overflow: hidden;
}

.app-topbar-notification-dropdown.v-popper__popper .v-popper__inner {
  width: 320px;
  max-width: calc(100vw - 16px);
}

.app-topbar-notification-dropdown .app-topbar-notification-content {
  max-height: 70vh;
  overflow: hidden;
}

.app-topbar-notification-dropdown .app-topbar-notification-content .notification-sidebar-content {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.app-topbar-avatar-dropdown.v-popper__popper .v-popper__inner {
  width: 220px;
}

.app-topbar-popover {
  max-width: none;
}

.app-global-topbar__brand {
    font-weight: 700;
    font-size: 18px;
    letter-spacing: 0.02em;
    background: linear-gradient(to right, #601895, #118477);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.app-global-topbar__brand-wrap {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.app-global-topbar__logo {
  padding: 4px;
  object-fit: contain;
  display: block;
}

.app-root__shell {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.app-root {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-root--fullscreen-route {
  height: 100vh;
  height: 100svh;
}

.app-root--fullscreen-route .app-root__shell {
  flex: 1 1 auto;
  min-height: 100vh;
  min-height: 100svh;
  overflow: visible;
}

/*
 * vue-js-popover có thể gán z-index thấp; global topbar 1100 > TopNavbar messenger (1000).
 * Giữ popover dưới modal (2000).
 */
.vue-popover {
  z-index: 1600 !important;
}

/* Menu avatar sidebar cũ: mở sang vùng chat — trên TopNavbar chat. */
.vue-popover.sidebar-account-popover {
  z-index: 10060 !important;
}

/* Ensure global overlays (modals) always sit above the topbar. */
.v--modal-overlay,
.v--modal-box,
.v--modal-background-click {
  z-index: 2100 !important;
}

.vm--container,
.vm--overlay,
.vm--modal {
  z-index: 2100 !important;
}

/* Bootstrap-style modals/backdrops (if used anywhere). */
.modal-backdrop,
.modal {
  z-index: 2100 !important;
}
</style>
